export const heraldics = [
    {
        "id": 1,
        "name": "Adaži",
        "path": "./Heraldics/Adazi.svg",
        "hint": "Relatīvi jauna pilsēta ar vēsturiskām aizvienām, netālu no Rīgas un Gaujas upes. Pazīstama ar Latvijas Gaisa spēku muzeju, kas piedāvā ieskatu valsts aviācijas vēsturē."
    },
    {
        "id": 2,
        "name": "Ainaži",
        "path": "./Heraldics/Ainazi.svg",
        "hint": "Mazākā Vidzemes pilsēta ar senām lībiešu zvejnieku ciemata saknēm. Slavena ar savu vēsturisko lomu kuģu būvē un jūrniecībā, kā arī ar iespējām baudīt ūdens sportu un dabas skaistumu pie Baltijas jūras."
    },
    {
        "id": 3,
        "name": "Aizkraukle",
        "path": "./Heraldics/Aizkraukle.svg",
        "hint": "Pilsēta Daugavas krastā, pazīstama ar hidroelektrostaciju un tās radīto Pļaviņu ūdenskrātuvi."
    },
    {
        "id": 4,
        "name": "Aizpute",
        "path": "./Heraldics/Aizpute.svg",
        "hint": "Viena no senākajām pilsētām Latvijā ar bagātu vēsturi un unikālu koka arhitektūru. Slavena ar Kurzemes bīskapijas centru." 
    },
    {
        "id": 5,
        "name": "Aknīste",
        "path": "./Heraldics/Akniste.svg",
        "hint": "Pilsēta Dienvidsusējas krastos, kas vēsturiski bijusi Lietuvas daļa. Pazīstama ar Aknīstes novadpētniecības muzeju, kurā var uzzināt par vietējo vēsturi un kultūru."
    },
    {
        "id": 6,
        "name": "Aloja",
        "path": "./Heraldics/Aloja.svg",
        "hint": "Klusa un romantiska pilsētiņa Vidzemē, netālu no Igaunijas robežas. Slavena ar savām muižām un dabas takām, kas piemērotas atpūtai brīvā dabā."
    },
    {
        "id": 7,
        "name": "Alūksne",
        "path": "./Heraldics/Aluksne.svg",
        "hint": "Šī pilsēta Vidzemes austrumos ir pazīstama ar gleznaino ezeru, Livonijas ordeņa pils drupām un muižas parku."
    },
    {
        "id": 8,
        "name": "Ape",
        "path": "./Heraldics/Ape.svg",
        "hint": "Ziemeļaustrumu pilsēta netālu no Igaunijas robežas, pazīstama kā viena no mazākajām Latvijas pilsētām ar bagātīgu dabu un vēsturiskām vietām."
    },
    {
        "id": 9,
        "name": "Auce",
        "path": "./Heraldics/Auce.svg",
        "hint": "Šī pilsēta Zemgalē ir slavena ar tās 19. gadsimta historicisma stila pili, kas ir viens no iecienītākajiem tūrisma objektiem reģionā."
    },
    {
        "id": 10,
        "name": "Baldone",
        "path": "./Heraldics/Baldone.svg",
        "hint": "Šī pilsēta Pierīgā ir pazīstama ar saviem vēsturiskajiem sēravotiem un kādreizējo spa kūrortu."
    },
    {
        "id": 11,
        "name": "Baloži",
        "path": "./Heraldics/Balozi.svg",
        "hint": "Šī pilsēta Pierīgā ir radusies ap kūdras fabriku, kas tika dibināta pēc Otrā pasaules kara."
    },
    {
        "id": 12,
        "name": "Balvi",
        "path": "./Heraldics/Balvi.svg",
        "hint": "Šī pilsēta Latgalē atrodas gleznainā vietā pie divu ezeru krastiem un ir nozīmīgs Latgales tradīciju centrs."
    },
    {
        "id": 13,
        "name": "Bauska",
        "path": "./Heraldics/Bauska.svg",
        "hint": "Šī Zemgales pilsēta atrodas pie divu upju saplūšanas, veidojot lielāko upi Latvijā, un ir pazīstama kā kultūrtūrisma centrs ar iespaidīgām pilīm."
    },
    {
        "id": 14,
        "name": "Brocēni",
        "path": "./Heraldics/Broceni.svg",
        "hint": "Šī Kurzemes pilsēta atrodas pie ezera krasta un ir pazīstama ar cementa un šīfera ražošanu."
    },
    {
        "id": 15,
        "name": "Cēsis",
        "path": "./Heraldics/Cesis.svg",
        "hint": "Šī Vidzemes pilsēta ar vairāk nekā 800 gadu senu vēsturi ir viena no vislabāk saglabātajām viduslaiku pilsētām Baltijā un tiek uzskatīta par Latvijas karoga dzimteni."
    },
    {
        "id": 16,
        "name": "Cēsvaine",
        "path": "./Heraldics/Cesvaine.svg",
        "hint": "Šī Vidzemes pilsēta ir pazīstama ar 19. gadsimta medību pili, kas celta blakus viduslaiku pilsdrupām."
    },
    {
        "id": 17,
        "name": "Dagda",
        "path": "./Heraldics/Dagda.svg",
        "hint": "Šī Latgales pilsēta ir pazīstama ar savu 17. gadsimta muižu un tās kādreizējo lomu kā vienam no lielākajiem tirdzniecības centriem reģionā."
    },
    {
        "id": 18,
        "name": "Daugavpils",
        "path": "./Heraldics/Daugavpils.svg",
        "hint": "Šī otrā lielākā Latvijas pilsēta atrodas Daugavas krastos un ir bagāta ar vēsturi, multikulturālu mantojumu un iespaidīgu cietoksni."
    },
    {
        "id": 19,
        "name": "Dobele",
        "path": "./Heraldics/Dobele.svg",
        "hint": "Šī Zemgales pilsēta uz Bērze upes krastiem lepojas ar pēdējās nocietinātās sēļu apmetnes drupām, kas pretojās Livonijas ordenim."
    },
    {
        "id": 20,
        "name": "Durbe",
        "path": "./Heraldics/Durbe.svg",
        "hint": "Kurzemes dienvidu pilsētiņa ar mazāk nekā 500 iedzīvotājiem ir slavena ar savu ābeļu dārziem un 13. gadsimta kaujas vietu."
    },
    {
        "id": 21,
        "name": "Grobiņa",
        "path": "./Heraldics/Grobina.svg",
        "hint": "Šī pilsēta lepojas ar titulu par senāko rakstos precīzi minēto apdzīvotu vietu Latvijas teritorijā, un tās vēsture aizsniedzas līdz vikingu laikiem."
    },
    {
        "id": 22,
        "name": "Gulbene",
        "path": "./Heraldics/Gulbene.svg",
        "hint": "Šeit krustojas vairāki autoceļi, un atrodas sena Livonijas ordeņa pilsdrupas."
    },
    {
        "id": 23,
        "name": "Iecava",
        "path": "./Heraldics/Iecava.svg",
        "hint": "Šeit, Lielupes pietekas krastos, atrodas 15. gadsimtā rakstos pirmoreiz minēta pilsēta ar aptuveni 10 000 iedzīvotāju."
    },
    {
        "id": 24,
        "name": "Ikšķile",
        "path": "./Heraldics/Ikskile.svg",
        "hint": "Šī Vidzemes dienvidrietumu pilsēta pie Daugavas bija pirmā Livonijas bīskapijas galvaspilsēta."
    },
    {
        "id": 25,
        "name": "Ilūkste",
        "path": "./Heraldics/Ilukste.svg",
        "hint": "Šī Sēlijas dienvidaustrumu pilsēta atrodas pie Daugavas upes un ir pazīstama kā viens no Sēlijas kultūras centriem."
    },
    {
        "id": 26,
        "name": "Jaunjelgava",
        "path": "./Heraldics/Jaunjelgava.svg",
        "hint": "Šeit, Daugavas krastā ar senu vēsturi, atrodas 16. gadsimtā dibināta pilsēta, kas kādreiz bija pēc platības otra lielākā pilsēta Latvijā aiz Rīgas."
    },
    {
        "id": 27,
        "name": "Jekabpils",
        "path": "./Heraldics/Jekabpils.svg",
        "hint": "Šī pilsēta ir sadalīta Daugavas divās pusēs, un katra puse pieder pie atsevišķa reģiona - Sēlijas un Latgales."
    },
    {
        "id": 28,
        "name": "Jelgava",
        "path": "./Heraldics/Jelgava.svg",
        "hint": "Pilsēta, kas dibināta 13. gadsimtā un ir pazīstama ar savu pili un hercogu rezidenci."
    },
    {
        "id": 29,
        "name": "Jūrmala",
        "path": "./Heraldics/Jurmala.svg",
        "hint": "Kūrortpilsēta ar 24 kilometrus garu smilšu pludmali un koka arhitektūru, kas pazīstama kā vasaras galvaspilsēta."
    },
    {
        "id": 30,
        "name": "Kandava",
        "path": "./Heraldics/Kandava.svg",
        "hint": "Austrumkurzemes pilsētiņa ar senatnīgu arhitektūru, kas atrodas Abavas senlejas galā."
    },
    {
        "id": 31,
        "name": "Kārsava",
        "path": "./Heraldics/Karsava.svg",
        "hint": "Šī Latgales pilsēta atrodas netālu no Krievijas robežas un ir pazīstama ar savām katoļu un pareizticīgo baznīcām."
    },
    {
        "id": 32,
        "name": "Ķegums",
        "path": "./Heraldics/Kegums.svg",
        "hint": "Pilsēta Daugavas krastā, kur atrodas pirmā Daugavas hidroelektrostacija."
    },
    {
        "id": 33,
        "name": "Ķekava",
        "path": "./Heraldics/Kekava.svg",
        "hint": "Pēckara putnu fabrikas mājvieta, kas tagad ir lielākais vistu gaļas ražotājs Latvijā."
    },
    {
        "id": 34,
        "name": "Koknese",
        "path": "./Heraldics/Koknese.svg",
        "hint": "Viduslaiku cietoksnis un latviešu folkloras tēla Lāčplēša mājvieta, kas atrodas pie divu upju – Daugavas un Pērses – satekas."
    },
    {
        "id": 35,
        "name": "Krāslava",
        "path": "./Heraldics/Kraslava.svg",
        "hint": "Seno tirdzniecības ceļu krustpunktā uz Daugavas abiem krastiem izvietojusies pilsēta, kas lepojas ar bagātu vēsturi un skaisto Daugavas loku dabas parku."
    },
    {
        "id": 36,
        "name": "Kuldīga",
        "path": "./Heraldics/Kuldiga.svg",
        "hint": "Pilsēta Kurzemes reģionā pie Ventas rumbas, kas slavena ar seno ķieģeļu tiltu un UNESCO aizsargāto vecpilsētu."
    },
    {
        "id": 37,
        "name": "Lielvārde",
        "path": "./Heraldics/Lielvarde.svg",
        "hint": "Pilsēta Vidzemes dienvidrietumos, kas pazīstama ar tradicionālo jostu ar sarkaniem un baltiem rakstiem un 22 seniem simboliem."
    },
    {
        "id": 38,
        "name": "Liepāja",
        "path": "./Heraldics/Liepaja.svg",
        "hint": "Ziemeļrietumu pilsēta ar 8 kilometrus garu pludmali, ko dēvē par vēju pilsētu un kuru 2027. gadā kronēs kā Eiropas kultūras galvaspilsētu."
    },
    {
        "id": 39,
        "name": "Līgatne",
        "path": "./Heraldics/Ligatne.svg",
        "hint": "Slavena ar savu papīrfabriku, kas darbojas kopš 1815. gada, kā arī dabas takām Gaujas nacionālajā parkā un padomju laika ieslodzīto nometnes memoriālu."
    },
    {
        "id": 40,
        "name": "Limbaži",
        "path": "./Heraldics/Limbazi.svg",
        "hint": "Senās Hanzas pilsēta ar viduslaiku pilsdrupām un bagātām podniecības tradīcijām."
    },
    {
        "id": 41,
        "name": "Līvāni",
        "path": "./Heraldics/Livani.svg",
        "hint": "Šī Latgales pilsēta ir pazīstama kā stikla mākslas centrs un atrodas Daugavas un Dubnas upju satekā."
    },
    {
        "id": 42,
        "name": "Lubāna",
        "path": "./Heraldics/Lubana.svg",
        "hint": "Vidzemes pilsēta Aiviekstes upes krastos."
    },
    {
        "id": 43,
        "name": "Ludza",
        "path": "./Heraldics/Ludza.svg",
        "hint": "Viduslaiku pilsdrupu un gleznainas vecpilsētas pilsēta, kas atrodas uz ezera krasta un ir slavena kā vecākā pilsēta Latvijā."
    },
    {
        "id": 44,
        "name": "Madona",
        "path": "./Heraldics/Madona.svg",
        "hint": "Vidzemes pilsēta ar vairākiem gleznainiem parkiem un augstāko strūklaku Latvijā."
    },
    {
        "id": 45,
        "name": "Mārupe",
        "path": "./Heraldics/Marupe.svg",
        "hint": "Blīvi apdzīvota Rīgas piepilsētas pilsēta, kas pazīstama ar savu individuālo māju apbūvi un vēsturiskajām spa kūrorta tradīcijām."
    },
    {
        "id": 46,
        "name": "Mazsalaca",
        "path": "./Heraldics/Mazsalaca.svg",
        "hint": "Populāra ar Salacas upes gleznaino posmu ar klintīm un alām, kā arī dabas takām un senatnīgas baznīcas."
    },
    {
        "id": 47,
        "name": "Ogre",
        "path": "./Heraldics/Ogre.svg",
        "hint": "Zaļa pilsētiņa pie divu upju satekas, kas vēsturiski pazīstama kā kūrortpilsēta ar tīru gaisu un plašām dabas atpūtas iespējām."
    },
    {
        "id": 48,
        "name": "Olaine",
        "path": "./Heraldics/Olaine.svg",
        "hint": "Industrija un dzīvojamās zonas līdzās Rīgai, ar vēsturisku nozīmi kūdras ieguvē."
    },
    {
        "id": 49,
        "name": "Pāvilosta",
        "path": "./Heraldics/Pavilosta.svg",
        "hint": "Maza ostas pilsētiņa Kurzemes rietumos, kas slavena ar zvejniecības tradīcijām un gleznaino jūras piekrasti."
    },
    {
        "id": 50,
        "name": "Piltene",
        "path": "./Heraldics/Piltene.svg",
        "hint": "Senā pilsēta ar bagātu vēsturi, kādreizējā Kurzemes bīskapijas centrs, ar ainaviskām Vecventas upes locēm un druvām."
    },
    {
        "id": 51,
        "name": "Pļaviņas",
        "path": "./Heraldics/Plavinas.svg",
        "hint": "Pilsēta Daugavas krastā ar vēsturiskām pēdamām un dabas skaistumu senlejas malā."
    },
    {
        "id": 52,
        "name": "Preiļi",
        "path": "./Heraldics/Preili.svg",
        "hint": "Latgales sirdī esoša pilsēta, kas glabā seno latgaļu mantojumu un lepojas ar katoļu tradīcijām un sieru ražošanu."
    },
    {
        "id": 53,
        "name": "Priekule",
        "path": "./Heraldics/Priekule.svg",
        "hint": "Dienvidkurzemes mazpilsēta ar vēsturi, kas aizsākās kā muiža, un kas mūsdienās pazīstama ar Zviedru vārtiem un kādreizējo dzelzceļa nozīmi."
    },
    {
        "id": 54,
        "name": "Rēzekne",
        "path": "./Heraldics/Rezekne.svg",
        "hint": "Pilsēta ar septiņiem pakalniem, kurā atrodas gan majestātiska katedrāle, gan senatnīga sinagoga, kā arī gleznainas dabas ainavas un bagāta kultūras dzīve."
    },
    {
        "id": 55,
        "name": "Rīga",
        "path": "./Heraldics/Riga.svg",
        "hint": "Vecrīgas viduslaiku šarms, jūgendstila ēkas un Daugavas plašums iezīmē pilsētas ainavu."
    },
    {
        "id": 56,
        "name": "Rūjiena",
        "path": "./Heraldics/Rujiena.svg",
        "hint": "Saldējuma paradīze un mākslinieku iedvesmas avots Ziemeļvidzemē."
    },
    {
        "id": 57,
        "name": "Sabile",
        "path": "./Heraldics/Sabile.svg",
        "hint": "Ziemeļkurzemes mazpilsēta, kas slavena ar vīnogu audzēšanas tradīcijām un simbolisko vīna kalnu."
    },
    {
        "id": 58,
        "name": "Salacgrīva",
        "path": "./Heraldics/Salacgriva.svg",
        "hint": "Vēstures piesātinātas pastaigas un gleznainas dabas ainavas Salacas upes krastos."
    },
    {
        "id": 59,
        "name": "Salaspils",
        "path": "./Heraldics/Salaspils.svg",
        "hint": "Seno apmetņu vēstures pieskāriens un Rīgas HES majestātiskais aizsprosts raksturo šo pilsētu."
    },
    {
        "id": 60,
        "name": "Saldus",
        "path": "./Heraldics/Saldus.svg",
        "hint": "Zaļās pilsētas lepnums - parki, laukumi un gleznaina upe, kas vijas cauri tās centram."
    },
    {
        "id": 61,
        "name": "Saulkrasti",
        "path": "./Heraldics/Saulkrasti.svg",
        "hint": "17 kilometrus garas smilšu pludmales un neaizmirstami saulrieti pievelk apmeklētājus uz šo piejūras pilsētu."
    },
    {
        "id": 62,
        "name": "Seda",
        "path": "./Heraldics/Seda.svg",
        "hint": "Pilsētas arhitektūra atspoguļo padomju laika mantojumu, ar iespaidīgām Staļina klasicisma ēkām, kas celtas ap kūdras ieguves vietu."
    },
    {
        "id": 63,
        "name": "Sigulda",
        "path": "./Heraldics/Sigulda.svg",
        "hint": "Adrenalīnu kāpinošas aktivitātes un elpu aizraujoši dabas skati, ieskaitot Gaujas senleju, padara šo pilsētu par piedzīvojumu meklētāju paradīzi."
    },
    {
        "id": 64,
        "name": "Skrunda",
        "path": "./Heraldics/Skrunda.svg",
        "hint": "Vēstures cienītājus apbur iespaidīgā Vācu ordeņa pils, bet mieru un klusumu meklētājus aicina nomaļās apkārtnes."
    },
    {
        "id": 65,
        "name": "Smiltene",
        "path": "./Heraldics/Smiltene.svg",
        "hint": "Zaļā un tīrā pilsēta ar vairākiem mākslīgiem ezeriem, kas izveidoti uz upes, piedāvā mierīgu atpūtu dabas ieskautā vidē."
    },
    {
        "id": 66,
        "name": "Staicele",
        "path": "./Heraldics/Staicele.svg",
        "hint": "Vēstures cienītājus aizrauj papīrfabrikas mantojums, bet kultūras entuziasti var iepazīt lībiešu tradīcijas."
    },
    {
        "id": 67,
        "name": "Stende",
        "path": "./Heraldics/Stende.svg",
        "hint": "Apmeklētājus aicina iepazīt vēsturisko sēļu apmetni, kas bija pēdējā, kas pretojās Livonijas ordenim."
    },
    {
        "id": 68,
        "name": "Strenči",
        "path": "./Heraldics/Strenci.svg",
        "hint": "Gaujas krastā zināms mežrūpniecības un transporta centrs, agrāk saukts par 'Gaujas plostnieku galvaspilsētu'."
    },
    {
        "id": 69,
        "name": "Subate",
        "path": "./Heraldics/Subate.svg",
        "hint": "Šī pilsēta, kas atrodas Sēlijas reģionā, lepojas ar divām daļām, kas piedāvā gan katoļu un luterāņu baznīcas, gan seno koka apbūvi."
    },
    {
        "id": 70,
        "name": "Valdemārpils",
        "path": "./Heraldics/Valdemarpils.svg",
        "hint": "Kurzemes ziemeļrietumos, pie gleznainā Sasmakas ezera, atrodas pilsēta, kas iemūžinājusi jaunlatviešu kustības ideologa Krišjāņa Valdemāra vārdu un aicina baudīt mierīgu atmosfēru dabas skaistuma ieskautā vidē."
    },
    {
        "id": 71,
        "name": "Valka",
        "path": "./Heraldics/Valka.svg",
        "hint": "Ziemeļvidzemē, uz pašas Latvijas un Igaunijas robežas, atrodas pilsēta, kas kopā ar kaimiņpilsētu Igaunijas pusē veido unikālu dvīņu pilsētu, piedāvājot iepazīt divu valstu kultūru un šarmu vienlaikus."
    },
    {
        "id": 72,
        "name": "Valmiera",
        "path": "./Heraldics/Valmiera.svg",
        "hint": "Vidzemes sirdī, gleznaino Gaujas krastu ieskauta, atrodas pilsēta, kas apvieno sevī senatnes vēsmas, ko iemūžina majestātiskā Livonijas ordeņa pils, ar mūsdienīgas pilsētas dinamiku un plašām izklaides iespējām."
    },
    {
        "id": 73,
        "name": "Vangaži",
        "path": "./Heraldics/Vangazi.svg",
        "hint": "Vidzemes austrumos, starp Gaujas upi un autoceļu A2, atrodas pilsēta, kas radusies pateicoties dzelzsbetona konstrukciju rūpnīcai un piedāvā iespēju atpūsties pie bijušā karjera ezera."
    },
    {
        "id": 74,
        "name": "Varakļāni",
        "path": "./Heraldics/Varaklani.svg",
        "hint": "Latgales un Vidzemes pierobežā, atrodas pilsēta ar bagātu vēsturi, kas ietver gan 18. gadsimta muižas pili, gan vairākas konfesiju baznīcas."
    },
    {
        "id": 75,
        "name": "Ventspils",
        "path": "./Heraldics/Ventspils.svg",
        "hint": "Rietumu Kurzemē, Baltijas jūras krastā, atrodas pilsēta, kas slavena ar savu neaizsalstošo ostu, plašo pludmali un unikālo pilsētas arhitektūru."
    },
    {
        "id": 76,
        "name": "Viesīte",
        "path": "./Heraldics/Viesite.svg",
        "hint": "Sēlijas centrā, Augšzemes augstienes paugurainajā apvidū, atrodas mazpilsēta, kas vilina ar kultūras centru 'Sēlija' un vēsturisko šaursliežu dzelzceļa depo teritoriju."
    },
    {
        "id": 77,
        "name": "Viļaka",
        "path": "./Heraldics/Vilakas.svg",
        "hint": "Ziemeļlatgales austrumos, atrodas pilsēta ar senatnīgu auru. Tās vēsturisko mantojumu apliecina gan Marienhauzenas pilsdrupas uz salas ezerā, gan trīs dažādu konfesiju baznīcas."
    },
    {
        "id": 78,
        "name": "Viļāni",
        "path": "./Heraldics/Vilani.svg",
        "hint": "Šī pilsēta, kas atrodas Latgales sirdī, pie Rēzeknes upes krastiem, aicina iepazīt vēsturisko Rēzeknes pili un gleznaino Daugavpils šosejas apkārtni."
    },
    {
        "id": 79,
        "name": "Zilupe",
        "path": "./Heraldics/Zilupe.svg",
        "hint": "Šī pilsēta, kas ir vistālākais austrumu punkts Latvijā, atrodas pie Zilupes upes, uz robežas ar Krieviju."
    }
]
